import { useState, useEffect } from 'react';
import API_CONFIG from '@shared/api/api.config';

export const useAvatarUrl = (avatar) => {
  const [timestamp, setTimestamp] = useState(Date.now());
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (avatar) {
      setTimestamp(Date.now());
    }
  }, [avatar]);

  const getBaseUrl = () => {
    const apiUrl = API_CONFIG.API_URL;
    if (!apiUrl) return window.location.origin;

    if (apiUrl.startsWith('/')) {
      return window.location.origin;
    }

    return apiUrl.replace(/\/api$/, '');
  };

  const getAvatarUrl = () => {
    if (!avatar) return null;

    if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
      return `${avatar}?t=${timestamp}`;
    }

    const baseUrl = getBaseUrl();
    if (!baseUrl) return null;

    let path = avatar.startsWith('/') ? avatar : `/${avatar}`;
    return `${baseUrl}${path}?t=${timestamp}`;
  };

  return {
    avatarUrl: getAvatarUrl(),
    imageError,
    setImageError,
    timestamp
  };
};